module.exports = __webpack_public_path__ + "img/icon-light-tracker.8b94a129.svg";